<template>
    <div>
        <div style="display: flex; align-items: center; justify-content: space-between">
            <a-breadcrumb style="margin: 16px 0">
                <a-breadcrumb-item>主页</a-breadcrumb-item>
                <a-breadcrumb-item>{{ selectFirstMenu }}</a-breadcrumb-item>
                <a-breadcrumb-item>{{ selectSecondMenu }}</a-breadcrumb-item>
            </a-breadcrumb>
            <div>
                <a-button class="qinang-button-margin" type="primary" icon="plus" @click="tableAdd">新增</a-button>
                <a-button class="qinang-button-margin" icon="edit" @click="tableEdit" :disabled="!tableSelectedRows || tableSelectedRows.length !== 1">修改</a-button>
                <a-button class="qinang-button-margin" icon="delete" @click="tableDel" :disabled="!tableSelectedRows || tableSelectedRows.length === 0">删除</a-button>
                <a-button icon="sync" @click="apiDistributorQueryList">刷新</a-button>
            </div>
        </div>

        <a-collapse expandIconPosition="right" activeKey="1">
            <a-collapse-panel key="1" header="分销商查询">
                <div class="qinang-search-row">
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title" style="width: 120px">服务商：</div>
                        <a-select v-model="query.facilitatorId" show-search option-filter-prop="children" :filter-option="filterOption" style="width: 100%" placeholder="请选择服务商" allowClear>
                            <a-select-option v-for="(item, index) in facilitatorList" :value="item.facilitatorId" :key="index">{{ item.facilitatorName }}</a-select-option>
                        </a-select>
                    </div>
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title" style="width: 120px">分销商名称：</div>
                        <a-input v-model="query.distributorName" style="width: 100%" placeholder="请输入分销商名称" />
                    </div>
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title" style="width: 120px">分销商类型：</div>
                        <a-select v-model="query.distributorType" style="width: 100%" placeholder="请选择类型" allowClear>
                            <a-select-option v-for="(item, index) in distributorTypeList" :value="item.value" :key="index">{{ item.label }}</a-select-option>
                        </a-select>
                    </div>
                </div>
                <div class="qinang-search-row" style="margin-top: 10px">
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title" style="width: 120px">状态：</div>
                        <a-select v-model="query.distributorState" style="width: 100%" placeholder="请选择状态" allowClear>
                            <a-select-option v-for="(item, index) in distributorStateList" :value="item.value" :key="index">{{ item.label }}</a-select-option>
                        </a-select>
                    </div>
                    <div class="qinang-search-col-3"></div>
                    <div class="qinang-search-col-3"></div>
                </div>
                <div class="qinang-margin-top-12 qinang-search-row" style="justify-content: center">
                    <a-button type="primary" icon="search" @click="apiDistributorQueryList">查询</a-button>
                    <a-button icon="redo" @click="resetQuery" style="margin-left: 14px">重置</a-button>
                </div>
            </a-collapse-panel>
        </a-collapse>

        <div class="qinang-card">
            <div style="display: flex; justify-content: space-between; align-items: center">
                <a-breadcrumb separator=">" style="padding: 12.5px 16px">
                    <a-breadcrumb-item>分销商列表</a-breadcrumb-item>
                </a-breadcrumb>
            </div>
            <a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="distributorId" :loading="tableLoading" :pagination="false">
                <span slot="distributorName" slot-scope="distributorName">
                    <a-button type="link" @click="edit(distributorName)">{{ distributorName.distributorName }}</a-button>
                </span>
                <span slot="distributorType" slot-scope="distributorType">
                    {{ distributorTypeMap[distributorType.distributorType] }}
                </span>
                <span slot="distributorState" slot-scope="distributorState">
                    <a-button type="link" @click="edit(distributorState)"> {{ distributorStateMap[distributorState.distributorState] }}</a-button>
                </span>
                <span slot="facilitator" slot-scope="facilitator">
                    {{ facilitatorName(facilitator.facilitatorId) }}
                </span>
                <span slot="createTime" slot-scope="createTime">
                    {{ qaUtil.timeFormat(createTime.createTime) }}
                </span>
                <span slot="accountBalance" slot-scope="accountBalance">
                    {{ accountBalance.accountBalance / 100 }}
                </span>
                <span slot="authBalance" slot-scope="authBalance">
                    <span v-if="authBalance.isPreauth == 2">-</span>
                    <span v-else>{{ authBalance.authBalance / 100 }}</span>
                </span>
                <span slot="adjust" slot-scope="adjust">
                    <a-button type="primary" size="small" @click="adjustBalance(adjust)">余额调整</a-button>
                </span>
            </a-table>
            <a-pagination style="text-align: right; margin: 10px" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']" :show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange" />
        </div>

        <!-- 添加弹窗 -->
        <a-modal class="qa-modal-hf" title="添加" width="900px" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="handleCancel" :maskClosable="false" :keyboard="false">
            <a-form-model ref="addRuleForm" :model="addForm" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" :rules="addRules">
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="分销商名称" has-feedback prop="distributorName">
                            <a-input v-model="addForm.distributorName" placeholder="请输入分销商名称" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="分销商类型" prop="distributorType">
                            <a-radio-group name="distributorType" v-model="addForm.distributorType">
                                <a-radio v-for="item in distributorTypeList" :value="item.value" :key="item.value">{{ item.label }}</a-radio>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="关联用户" has-feedback prop="touristId">
                            <a-select v-model="addForm.touristId" show-search :filter-option="false" @search="handleSearchTourist" placeholder="请输入姓名搜索用户" allowClear>
                                <a-select-option v-for="item in touristList" :key="item.touristId" :value="item.touristId">{{ item.realName }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="服务商" prop="facilitatorId">
                            <a-select v-model="addForm.facilitatorId" show-search option-filter-prop="children" :filter-option="filterOption" placeholder="请选择服务商" allowClear>
                                <a-select-option v-for="(item, index) in facilitatorList" :value="item.facilitatorId" :key="index">{{ item.facilitatorName }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="联系人" has-feedback prop="contactName">
                            <a-input v-model="addForm.contactName" placeholder="请输入联系人" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="联系电话" has-feedback prop="contactPhone">
                            <a-input v-model="addForm.contactPhone" placeholder="请输入联系电话" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="身份证号" has-feedback prop="idCard">
                            <a-input v-model="addForm.idCard" placeholder="请输入身份证号" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="是否预付" prop="isPreauth">
                            <a-radio-group name="isPreauth" v-model="addForm.isPreauth">
                                <a-radio :value="3">是</a-radio>
                                <a-radio :value="2">否</a-radio>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="账户余额" has-feedback prop="accountBalance">
                            <a-input-number v-model="addForm.accountBalance" :min="0" disabled style="width: 100%" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="授信余额" has-feedback prop="authBalance">
                            <a-input-number v-model="addForm.authBalance" :min="0" disabled style="width: 100%" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="回款税率" prop="repayTax">
                            <a-input-number v-model="addForm.repayTax" :min="0" :max="100" addon-after="%" style="width: 100%" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="个税税率" prop="incomeTax">
                            <a-input-number v-model="addForm.incomeTax" :min="0" :max="100" addon-after="%" style="width: 100%" />
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="真实姓名" has-feedback prop="realName">
                            <a-input v-model="addForm.realName" placeholder="请输入真实姓名" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="银行卡号" has-feedback prop="bankCard">
                            <a-input v-model="addForm.bankCard" placeholder="请输入银行卡号" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="开户行" has-feedback prop="bankName">
                            <a-input v-model="addForm.bankName" placeholder="请输入开户行" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="状态" has-feedback prop="distributorState">
                            <a-select v-model="addForm.distributorState" placeholder="请选择状态" style="width: 100%">
                                <a-select-option v-for="(item, index) in distributorStateList" :value="item.value" :key="index">{{ item.label }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="24">
                        <a-form-model-item label="备注" has-feedback prop="remarks" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                            <a-textarea v-model="addForm.remarks" placeholder="请输入备注，非必填项" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
        </a-modal>

        <!-- 修改弹窗 -->
        <a-modal class="qa-modal-hf" title="修改" width="900px" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="handleCancel" :maskClosable="false" :keyboard="false">
            <a-form-model ref="editRuleForm" :model="editForm" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" :rules="addRules">
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="分销商名称" prop="distributorName">
                            <a-input v-model="editForm.distributorName" placeholder="请输入分销商名称" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="分销商类型" prop="distributorType">
                            <a-radio-group name="distributorType" v-model="editForm.distributorType">
                                <a-radio v-for="item in distributorTypeList" :value="item.value" :key="item.value">{{ item.label }}</a-radio>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="关联用户" has-feedback prop="touristId">
                            <a-select v-model="editForm.touristId" show-search :filter-option="false" @search="handleSearchTourist" @change="onTouristChange" placeholder="请输入姓名搜索用户" allowClear>
                                <a-select-option v-for="item in touristList" :key="item.touristId" :value="item.touristId">{{ item.realName }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="服务商" prop="facilitatorId">
                            <a-select v-model="editForm.facilitatorId" show-search option-filter-prop="children" :filter-option="filterOption" placeholder="请选择服务商" allowClear>
                                <a-select-option v-for="(item, index) in facilitatorList" :value="item.facilitatorId" :key="index">{{ item.facilitatorName }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="联系人" has-feedback prop="contactName">
                            <a-input v-model="editForm.contactName" placeholder="请输入联系人" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="联系电话" has-feedback prop="contactPhone">
                            <a-input v-model="editForm.contactPhone" placeholder="请输入联系电话" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="身份证号" has-feedback prop="idCard">
                            <a-input v-model="editForm.idCard" placeholder="请输入身份证号" />
                        </a-form-model-item>
                    </a-col>

                    <a-col :span="12">
                        <a-form-model-item label="是否预付" prop="isPreauth">
                            <a-radio-group name="isPreauth" v-model="editForm.isPreauth">
                                <a-radio :value="3">是</a-radio>
                                <a-radio :value="2">否</a-radio>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="账户余额" has-feedback prop="accountBalance">
                            <a-input-number v-model="editForm.accountBalance" :min="0" disabled style="width: 100%" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="授信余额" has-feedback prop="authBalance">
                            <a-input-number v-model="editForm.authBalance" :min="0" disabled style="width: 100%" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="回款税率" prop="repayTax">
                            <a-input-number v-model="editForm.repayTax" :min="0" :max="100" addon-after="%" style="width: 100%" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="个税税率" prop="incomeTax">
                            <a-input-number v-model="editForm.incomeTax" :min="0" :max="100" addon-after="%" style="width: 100%" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="真实姓名" has-feedback prop="realName">
                            <a-input v-model="editForm.realName" placeholder="请输入真实姓名" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="银行卡号" has-feedback prop="bankCard">
                            <a-input v-model="editForm.bankCard" placeholder="请输入银行卡号" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="开户行" has-feedback prop="bankName">
                            <a-input v-model="editForm.bankName" placeholder="请输入开户行" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="状态" has-feedback prop="distributorState">
                            <a-select v-model="editForm.distributorState" placeholder="请选择状态" style="width: 100%">
                                <a-select-option v-for="(item, index) in distributorStateList" :value="item.value" :key="index">{{ item.label }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="24">
                        <a-form-model-item label="备注" has-feedback prop="remarks" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                            <a-textarea v-model="editForm.remarks" placeholder="请输入备注，非必填项" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
        </a-modal>

        <!-- 余额调整弹窗 -->
        <a-modal class="qa-modal-hf" title="余额调整" width="500px" :visible="adjustVisible" :confirm-loading="adjustConfirmLoading" @ok="adjustHandleOk" @cancel="adjustCancel" :maskClosable="false" :keyboard="false">
            <a-form-model ref="adjustRuleForm" :model="adjustForm" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" :rules="adjustRules">
                <a-form-model-item label="分销商" prop="distributorName">
                    <a-input v-model="adjustForm.distributorName" disabled />
                </a-form-model-item>
                <a-form-model-item label="当前账户余额" prop="currentAccountBalance">
                    <a-input :value="(adjustForm.currentAccountBalance / 100).toFixed(2)" disabled addon-after="元" />
                </a-form-model-item>
                <a-form-model-item label="当前授信余额" prop="currentAuthBalance">
                    <a-input v-if="adjustNoPreauth" value="-" disabled addon-after="元" />
                    <a-input v-else :value="(adjustForm.currentAuthBalance / 100).toFixed(2)" disabled addon-after="元" />
                </a-form-model-item>
                <a-form-model-item label="调整类型" prop="sourceType">
                    <a-radio-group v-model="adjustForm.sourceType">
                        <a-radio :value="2" :disabled="adjustNoPreauth">授信余额</a-radio>
                        <a-radio :value="1">账户余额</a-radio>
                    </a-radio-group>
                </a-form-model-item>
                <a-form-model-item label="操作" prop="operateType">
                    <a-radio-group v-model="adjustForm.operateType">
                        <a-radio value="+">充值</a-radio>
                        <a-radio value="-">扣除</a-radio>
                    </a-radio-group>
                </a-form-model-item>
                <a-form-model-item label="调整金额" prop="money">
                    <a-input-number v-model="adjustForm.money" :min="0" :precision="2" style="width: 100%" placeholder="请输入调整金额（元）" />
                </a-form-model-item>
                <a-form-model-item label="备注" prop="remarks">
                    <a-textarea v-model="adjustForm.remarks" placeholder="请输入备注，非必填项" />
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selectFirstMenu: window.sessionStorage.getItem("selectFirstMenu"),
            selectSecondMenu: window.sessionStorage.getItem("selectSecondMenu"),
            facilitatorList: [],
            distributorTypeList: [
                { label: "个人", value: 2 },
                { label: "公司(机构)", value: 3 },
                { label: "平台", value: 4 }
            ],
            distributorStateList: [
                { label: "停用", value: 2 },
                { label: "启用", value: 3 },
                { label: "审核中", value: 5 },
                { label: "审核拒绝", value: 6 }
            ],
            distributorTypeMap: { 2: "个人", 3: "公司(机构)", 4: "平台" },
            distributorStateMap: {
                2: "停用",
                3: "启用",
                5: "审核中",
                6: "审核拒绝"
            },
            query: {
                page: 1,
                size: 10,
                total: 0,
                facilitatorId: undefined,
                distributorName: undefined,
                contactName: undefined,
                distributorType: undefined,
                distributorState: undefined
            },
            tableData: [],
            tableColumns: [
                {
                    title: "ID",
                    dataIndex: "distributorId",
                    key: "distributorId",
                    align: "center",
                    width: "80"
                },
                {
                    title: "分销商名称",
                    key: "distributorName",
                    align: "center",
                    width: "150",
                    scopedSlots: { customRender: "distributorName" }
                },
                {
                    title: "类型",
                    key: "distributorType",
                    align: "center",
                    width: "110",
                    scopedSlots: { customRender: "distributorType" }
                },
                {
                    title: "联系人姓名",
                    dataIndex: "contactName",
                    key: "contactName",
                    align: "center",
                    width: "100"
                },
                {
                    title: "联系人电话",
                    dataIndex: "contactPhone",
                    key: "contactPhone",
                    align: "center",
                    width: "130"
                },
                {
                    title: "服务商",
                    key: "facilitator",
                    align: "center",
                    width: "150",
                    scopedSlots: { customRender: "facilitator" }
                },
                {
                    title: "状态",
                    key: "distributorState",
                    align: "center",
                    width: "100",
                    scopedSlots: { customRender: "distributorState" }
                },
                {
                    title: "账户余额",
                    key: "accountBalance",
                    align: "center",
                    width: "100",
                    scopedSlots: { customRender: "accountBalance" }
                },
                {
                    title: "授信余额",
                    key: "authBalance",
                    align: "center",
                    width: "100",
                    scopedSlots: { customRender: "authBalance" }
                },

                {
                    title: "创建时间",
                    key: "createTime",
                    align: "center",
                    scopedSlots: { customRender: "createTime" }
                },
                {
                    title: "操作",
                    key: "adjust",
                    align: "center",
                    width: "110",
                    fixed: "right",
                    scopedSlots: { customRender: "adjust" }
                }
            ],
            tableLoading: false,
            tableSelectedRows: [],
            addVisible: false,
            addConfirmLoading: false,
            addForm: {
                distributorName: undefined,
                distributorType: 2,
                touristId: undefined,
                facilitatorId: undefined,
                contactName: undefined,
                contactPhone: undefined,
                idCard: undefined,
                realName: undefined,
                accountBalance: 0,
                authBalance: 0,
                repayTax: 0,
                incomeTax: 0,
                bankCard: undefined,
                bankName: undefined,
                isPreauth: 2,
                distributorState: 5,
                remarks: ""
            },
            addRules: {
                distributorName: [{ required: true, message: "分销商名称不能为空", trigger: "blur" }],
                distributorType: [{ required: true, message: "请选择分销商类型", trigger: "change" }],
                facilitatorId: [{ required: true, message: "请选择服务商", trigger: "change" }],
                isPreauth: [{ required: true, message: "请选择是否预付", trigger: "change" }]
            },
            editVisible: false,
            editConfirmLoading: false,
            editForm: {
                distributorId: "",
                distributorName: undefined,
                distributorType: 2,
                touristId: undefined,
                facilitatorId: undefined,
                contactName: undefined,
                contactPhone: undefined,
                idCard: undefined,
                realName: undefined,
                accountBalance: 0,
                authBalance: 0,
                repayTax: 0,
                incomeTax: 0,
                bankCard: undefined,
                bankName: undefined,
                isPreauth: undefined,
                distributorState: 5,
                remarks: "",
                _originTouristId: 0
            },

            adjustVisible: false,
            adjustNoPreauth: false,
            adjustConfirmLoading: false,
            adjustForm: {
                distributorId: "",
                distributorName: "",
                currentAccountBalance: 0,
                currentAuthBalance: 0,
                sourceType: 2,
                operateType: "+",
                money: 0,
                remarks: ""
            },
            adjustRules: {
                money: [{ required: true, message: "请输入调整金额", trigger: "blur" }]
            },
            touristList: [],
            touristTouched: false,
            searchTimer: null
        }
    },
    methods: {
        async apiFacilitatorList() {
            const { data: res } = await this.$http.post(this.navigation.apiFacilitatorList, { staffId: window.sessionStorage.getItem("staffId") })
            if (res.code == 200) {
                this.facilitatorList = res.data
            } else {
                this.$message.error(res.msg)
            }
        },
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        },
        facilitatorName(facilitatorId) {
            if (!facilitatorId) return ""
            const f = this.facilitatorList.find(item => item.facilitatorId == facilitatorId)
            return f ? f.facilitatorName : facilitatorId
        },
        resetQuery() {
            this.query = {
                page: 1,
                size: 10,
                total: 0,
                facilitatorId: undefined,
                distributorName: undefined,
                contactName: undefined,
                distributorType: undefined,
                distributorState: undefined
            }
            this.apiDistributorQueryList()
        },

        async apiDistributorQueryList() {
            this.tableLoading = true
            const { data: res } = await this.$http.post(this.navigation.apiDistributorQueryList, this.query)
            if (res.code == 200) {
                this.tableData = res.data.list
                this.query.page = res.data.pages.page
                this.query.size = res.data.pages.size
                this.query.total = res.data.pages.total
                this.tableLoading = false
            } else {
                this.$message.error(res.msg)
                this.tableLoading = false
            }
        },
        pageChange(page, pageSize) {
            this.query.page = page
            this.query.size = pageSize
            this.apiDistributorQueryList()
        },
        showSizeChange(current, size) {
            this.query.page = current
            this.query.size = size
            this.apiDistributorQueryList()
        },
        handleCancel() {
            this.addVisible = false
            this.editVisible = false
        },
        tableAdd() {
            this.touristList = []
            this.touristTouched = false
            this.addVisible = true
            this.addConfirmLoading = false
            this.addForm = {
                distributorName: undefined,
                distributorType: 2,
                touristId: undefined,
                facilitatorId: undefined,
                contactName: undefined,
                contactPhone: undefined,
                idCard: undefined,
                realName: undefined,
                accountBalance: 0,
                authBalance: 0,
                repayTax: 0,
                incomeTax: 0,

                bankCard: undefined,
                bankName: undefined,
                isPreauth: 2,
                distributorState: 5,
                remarks: ""
            }
            if (this.$refs.addRuleForm) this.$refs.addRuleForm.resetFields()
        },
        async apiDistributorAdd() {
            this.addConfirmLoading = true
            const params = { ...this.addForm }
            params.facilitatorId = params.facilitatorId || 0
            params.touristId = params.touristId || 0
            params.distributorState = params.distributorState || 5
            params.repayTax = params.repayTax ? Number((params.repayTax / 100).toFixed(4)) : 0
            params.incomeTax = params.incomeTax ? Number((params.incomeTax / 100).toFixed(4)) : 0

            params.accountBalance = params.accountBalance ? Math.round(params.accountBalance * 100) : 0
            params.authBalance = params.authBalance ? Math.round(params.authBalance * 100) : 0
            const { data: res } = await this.$http.post(this.navigation.apiDistributorAdd, params)
            if (res.code == 200) {
                this.$message.success(res.msg)
                if (this.$refs.addRuleForm) this.$refs.addRuleForm.resetFields()
                this.addConfirmLoading = false
                this.addVisible = false
                this.apiDistributorQueryList()
            } else {
                this.$message.error(res.msg)
                this.addConfirmLoading = false
            }
        },
        addHandleOk() {
            this.$refs.addRuleForm.validate(valid => {
                if (valid) {
                    this.apiDistributorAdd()
                } else {
                    return false
                }
            })
        },
        async edit(item) {
            this.editConfirmLoading = false
            this.editVisible = true
            this.touristTouched = false
            this.editForm = { ...item }
            this.editForm.facilitatorId = item.facilitatorId || undefined
            this.editForm.repayTax = item.repayTax ? Number((item.repayTax * 100).toFixed(4)) : 0
            this.editForm.incomeTax = item.incomeTax ? Number((item.incomeTax * 100).toFixed(4)) : 0

            this.editForm.accountBalance = item.accountBalance ? item.accountBalance / 100 : 0
            this.editForm.authBalance = item.authBalance ? item.authBalance / 100 : 0
            this.editForm.touristId = this.editForm.touristId ? this.editForm.touristId : undefined
            this.editForm._originTouristId = this.editForm.touristId || 0
            this.touristList = []
            if (this.editForm.touristId) {
                this.$http
                    .post(this.navigation.apiPromotionUserQueryList, {
                        page: 1,
                        size: 1,
                        touristId: this.editForm.touristId
                    })
                    .then(({ data: res }) => {
                        if (res.code == 200 && res.data.list && res.data.list.length) {
                            this.touristList = res.data.list
                        }
                    })
            }
        },
        async apiDistributorEdit() {
            this.editConfirmLoading = true
            const params = { ...this.editForm }
            params.facilitatorId = params.facilitatorId || 0
            if (!this.touristTouched) {
                params.touristId = this.editForm._originTouristId
            } else {
                params.touristId = params.touristId || 0
            }
            params.repayTax = params.repayTax ? Number((params.repayTax / 100).toFixed(4)) : 0
            params.incomeTax = params.incomeTax ? Number((params.incomeTax / 100).toFixed(4)) : 0
            params.accountBalance = params.accountBalance ? Math.round(params.accountBalance * 100) : 0
            params.authBalance = params.authBalance ? Math.round(params.authBalance * 100) : 0

            delete params._originTouristId
            const { data: res } = await this.$http.post(this.navigation.apiDistributorEdit, params)
            if (res.code == 200) {
                this.$message.success(res.msg)
                this.editConfirmLoading = false
                this.editVisible = false
                this.apiDistributorQueryList()
            } else {
                this.$message.error(res.msg)
                this.editConfirmLoading = false
            }
        },
        editHandleOk() {
            this.$refs.editRuleForm.validate(valid => {
                if (valid) {
                    this.apiDistributorEdit()
                } else {
                    return false
                }
            })
        },
        adjustBalance(record) {
            this.adjustVisible = true
            this.adjustConfirmLoading = false
            this.adjustNoPreauth = record.isPreauth == 2
            this.adjustForm = {
                distributorId: record.distributorId,
                distributorName: record.distributorName,
                currentAccountBalance: record.accountBalance || 0,
                currentAuthBalance: record.authBalance || 0,
                sourceType: this.adjustNoPreauth ? 1 : 2,
                operateType: "+",
                money: 0,
                remarks: ""
            }
        },
        async apiDistributorAdjustBalance() {
            this.adjustConfirmLoading = true
            const params = {
                distributorId: this.adjustForm.distributorId,
                sourceType: this.adjustForm.sourceType,
                operateType: this.adjustForm.operateType,
                money: Math.round((this.adjustForm.money || 0) * 100),
                remarks: this.adjustForm.remarks
            }
            const { data: res } = await this.$http.post(this.navigation.apiDistributorAdjustBalance, params)
            if (res.code == 200) {
                this.$message.success(res.msg)
                await this.apiDistributorQueryList()
                const updated = this.tableData.find(item => item.distributorId == this.adjustForm.distributorId)
                if (updated) {
                    this.adjustForm.currentAccountBalance = updated.accountBalance || 0
                    this.adjustForm.currentAuthBalance = updated.authBalance || 0
                }
                this.adjustForm.money = 0
                this.adjustForm.remarks = ""
                this.adjustConfirmLoading = false
                this.adjustVisible = false
            } else {
                this.$message.error(res.msg)
                this.adjustConfirmLoading = false
            }
        },
        adjustHandleOk() {
            this.$refs.adjustRuleForm.validate(valid => {
                if (valid) {
                    this.apiDistributorAdjustBalance()
                } else {
                    return false
                }
            })
        },
        adjustCancel() {
            this.adjustVisible = false
        },
        tableDel() {
            let that = this
            if (this.tableSelectedRows.length > 0) {
                const ids = this.tableSelectedRows.map(row => row.distributorId)
                this.$confirm({
                    title: "确定要删除当前选中数据吗",
                    content: "当前选中" + ids.length + "条数据。",
                    okText: "确定",
                    okType: "danger",
                    cancelText: "取消",
                    onOk() {
                        that.apiDistributorDel(ids)
                    },
                    onCancel() {}
                })
            } else {
                this.$message.warning("请选择要删除的数据")
            }
        },
        async apiDistributorDel(ids) {
            const { data: res } = await this.$http.post(this.navigation.apiDistributorDel + "/" + ids)
            if (res.code == 200) {
                this.$message.success(res.msg)
                await this.apiDistributorQueryList()
            } else {
                this.$message.error(res.msg)
            }
        },

        tableEdit() {
            if (this.tableSelectedRows.length === 1) {
                const item = this.tableData.find(item => item.distributorId == this.tableSelectedRows[0].distributorId)
                this.edit(item)
            } else {
                this.$message.warning("请选择要修改的数据")
            }
        },
        handleSearchTourist(keyword) {
            clearTimeout(this.searchTimer)
            if (!keyword || !keyword.trim()) {
                this.touristList = []
                return
            }
            this.searchTimer = setTimeout(() => {
                this.$http
                    .post(this.navigation.apiPromotionUserQueryList, {
                        page: 1,
                        size: 20,
                        realName: keyword.trim()
                    })
                    .then(({ data: res }) => {
                        if (res.code == 200) {
                            this.touristList = res.data.list || []
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
            }, 300)
        },
        onTouristChange() {
            this.touristTouched = true
        }
    },
    computed: {
        rowSelection() {
            let that = this
            return {
                onChange: (selectedRowKeys, selectedRows) => {
                    that.tableSelectedRows = selectedRows
                }
            }
        }
    },
    created() {
        this.apiFacilitatorList()
        this.apiDistributorQueryList()
    }
}
</script>

<style scoped>
.qa-modal ::v-deep .ant-form {
    overflow-y: auto;
}

.qa-modal ::v-deep .ant-modal {
    width: auto !important;
    max-width: 80vw;
}

.qa-modal ::v-deep .ant-modal-content {
    background-color: #fff;
    width: auto;
}

.qa-modal ::v-deep .ant-modal-body {
    max-height: calc(100vh - 110px);
    overflow-y: auto;
    padding: 24px;
    width: auto;
    position: relative;
}
</style>
